import { module } from 'stereomodularjs';

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {
		let videoEl = this.el;
		videoEl.play();
	}
}
